<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Testimonial Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editTestimonial">Edit Testimonial</button>
                </div>
            </div>
            <div class="table-responsive" v-if="testimonial">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{testimonial.pkCarouselId}}</td>
                    </tr>
                  <tr>
                    <th>Page </th>
                    <td>{{testimonial.pageName}}</td>
                  </tr>
                    <tr>
                        <th>Author</th>
                        <td>{{testimonial.author}}</td>
                    </tr>
                    <tr>
                        <th>Designation</th>
                        <td>{{testimonial.designation}}</td>
                    </tr>
                  <tr>
                    <th>Location</th>
                    <td>{{testimonial.location}}</td>
                  </tr>
                    <tr>
                        <th>Quote</th>
                        <td>{{testimonial.quote}}</td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="testimonial.isActive == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewTestimonialt',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GETSELECTEDTESTIMONIAL', this.$route.params.id).then(() =>{
            this.testimonial = this.selectedTestimonial;
        })

    },
    data () {
        return {
          testimonial: {}
        }
    },
    methods: {
        editTestimonial(){
            this.$router.push({ name: 'EditTestimonial', params: { id: this.testimonial.pkCarouselId}})
        },
    },
    computed: {...mapGetters([
        'selectedTestimonial'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Testimonials/TestimonialDetails.vue